export default {"src":"/_next/static/media/filterIcon.452a1ef4.svg","height":18,"width":27};